import { render, staticRenderFns } from "./editwidgets.vue?vue&type=template&id=0bbb7634&"
import script from "./editwidgets.vue?vue&type=script&lang=js&"
export * from "./editwidgets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports